import { render, staticRenderFns } from "./blackFooter.vue?vue&type=template&id=0ba43122&"
import script from "./blackFooter.vue?vue&type=script&lang=js&"
export * from "./blackFooter.vue?vue&type=script&lang=js&"
import style0 from "./blackFooter.vue?vue&type=style&index=0&id=0ba43122&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports